import { render } from "./ConfirmarEnvio.vue?vue&type=template&id=1958e72c&scoped=true"
import script from "./ConfirmarEnvio.vue?vue&type=script&lang=js"
export * from "./ConfirmarEnvio.vue?vue&type=script&lang=js"

import "./ConfirmarEnvio.vue?vue&type=style&index=0&id=1958e72c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1958e72c"]])

export default __exports__